import classNames from 'classnames';
import * as React from 'react';
import { CnEllipsis } from '@/components/cn-ellipsis';
export const DefaultFormat = (props) => {
    const { column, rowIndex, mode, data } = props;
    const { dataIndex, getCellProps, cell } = column;
    if (!dataIndex)
        return React.createElement(React.Fragment, null, "- -");
    const value = data[dataIndex] ? data[dataIndex] : undefined;
    const { onClick: onClickProps, ...cellProps } = getCellProps?.(data[dataIndex], data, rowIndex) || {};
    const onClick = (event) => {
        if (!onClickProps)
            return;
        onClickProps(event);
        if (mode === 'simple')
            event.stopPropagation();
    };
    if (cell && typeof cell === 'function') {
        return (React.createElement("span", { ...cellProps, onClick: onClick }, cell?.(value, rowIndex, data) || '- -'));
    }
    if (value && typeof value === 'object') {
        const { value: _value, text, link, toolTips, ...rest } = value;
        const style = {
            color: rest.color,
        };
        const content = (_value ?? text) || '- -';
        if (mode === 'simple') {
            return React.createElement(CnEllipsis, { style: style }, content);
        }
        return (React.createElement("span", { className: classNames({ 'cn-table-format-text-link': !!link }), style: style, onClick: () => link && window.open(link) }, content));
    }
    if (mode === 'simple' && value) {
        return React.createElement(CnEllipsis, null, value);
    }
    return (React.createElement("span", { ...cellProps, onClick: onClick }, value || '- -'));
};
